// schema
import * as ISchema from "@schema";

import moment from "moment-timezone";
import { validateEventTime } from "@clockwise/client-commons/src/util/event-time";
import { getRenderTimeZone, ZonedMoment } from "@util/time-zone.util";
import { getMomentForSlot, GetMomentForSlotSlot } from "@util/scheduling-slot.util";

export function eventTimeToZonedMoment(eventTime: ISchema.IEventTime): ZonedMoment | null {
  if (!validateEventTime(eventTime)) {
    return null;
  }
  if (eventTime.type === "Date") {
    const dateMoment = moment.tz(eventTime.dateOrDateTime, eventTime.timeZone);
    return new ZonedMoment(dateMoment);
  }
  return new ZonedMoment(eventTime.millis);
}

export type GetEventTimeForSchedulingSlot = GetMomentForSlotSlot;
export function getEventTimeForSchedulingSlot(
  schedulingSlot: GetEventTimeForSchedulingSlot,
): ISchema.IEventTimeInput {
  const slotMoment = getMomentForSlot(schedulingSlot);
  return {
    type: "DateTime" as ISchema.EventTimeType,
    millis: slotMoment.valueOf(),
    dateOrDateTime: slotMoment.toISOString(),
    timeZone: getRenderTimeZone(),
    offsetMinutes: slotMoment.utcOffset(),
  };
}
